import httpClient from "../utils/http";
import { ENDPOINTS } from "../utils/endpoints";
import type { IAdminUser, IResponse } from "../interfaces";
import type { IPagination } from "./grading";

/**
 * Get all users list for admin panel with pagination and search
 * @param params - Pagination and search parameters
 * @returns Promise with paginated users list
 */
export const getUsersList = async (params?: {
  page?: number;
  limit?: number;
  search?: string;
  roles?: string[];
  statuses?: string[];
  fromDate?: string;
  toDate?: string;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';
}): Promise<IResponse<{ users: IAdminUser[], pagination: IPagination }>> => {
  const queryParams: Record<string, string | number> = {};
  if (params?.page) queryParams.page = params.page;
  if (params?.limit) queryParams.limit = params.limit;
  if (params?.search) queryParams.search = params.search;
  if (params?.roles?.length) queryParams.roles = params.roles.join(",");
  if (params?.statuses?.length) queryParams.statuses = params.statuses.join(",");
  if (params?.fromDate) queryParams.fromDate = params.fromDate;
  if (params?.toDate) queryParams.toDate = params.toDate;
  if (params?.sortBy) queryParams.sortBy = params.sortBy;
  if (params?.sortOrder) queryParams.sortOrder = params.sortOrder;

  const response = await httpClient.get<IResponse<{ users: IAdminUser[], pagination: IPagination }>>(
    ENDPOINTS.GET_USERS,
    { params: queryParams }
  );

  return response.data;
};

/**
 * Get user by ID
 * @param userId - User ID
 * @returns Promise with user data
 */
export const getUserById = async (
  userId: string
): Promise<IResponse<IAdminUser>> => {
  const url = ENDPOINTS.GET_USER_BY_ID.replace(":id", userId);
  const response = await httpClient.get<IResponse<IAdminUser>>(url);
  return response.data;
};

export const deleteUser = async (userId: string): Promise<IResponse> => {
  const url = ENDPOINTS.SOFT_DELETE_USER.replace(":id", userId);
  const response = await httpClient.put<IResponse>(url);
  return response.data;
};
